<template>
  <div class="balanceRecord page-container">
    <div class="page-title">
      <span style="cursor: pointer;" @click="$router.push({ name: 'Merchant_List' })">
        <i class="el-icon-back" />
        {{ $route.params.merchant_name }}
      </span>
    </div>
    <div class="page-card">
      <svg-icon icon-class="transaction_records_icon" />
      <span style="margin-left: 14px;">{{ $t('menu.transaction_records') }}</span>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="(item,index) in componentConfig" :label="item.label" :name="item.compName" :key="index" />
    </el-tabs>
    <component :is="activeName" :key="activeName" />

  </div>
</template>

<script>

export default {
  name: 'Transaction_Records',
  components: {
    TransactionSummary: () => import('./components/TransactionSummary'),
    Payin: () => import('./components/Payin'),
    // Payout: () => import('./components/Payout.vue')
    Refund: () => import('./components/Refund.vue'),
    SplitTransaction: () => import('./components/SplitTransaction.vue')
  },
  data() {
    return {
      activeName: 'TransactionSummary'
    }
  },
  computed: {
    componentConfig() {
      return [
        { compName: 'TransactionSummary', label: this.$t('menu.transaction_summary') },
        { compName: 'Payin', label: this.$t('menu.payin') },
        // { compName: 'Payout', label: this.$t('menu.payout') }
        { compName: 'Refund', label: this.$t('menu.refund') },
        { compName: 'SplitTransaction', label: this.$t('menu.split_transaction') }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.balanceRecord{
  background-color: #fff;
  margin: 20px;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    text-align: right;
    padding-bottom: 22px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .icon-question{
    font-size: 11px;
    position: relative;
    top: -1px;
    left: 2px;
    cursor: pointer;
  }
}
.page-card {
  display: inline-block;
  // width: 180px;
  height: 40px;
  padding: 12px 24px;
  // align-items: center;
  margin: 18px 0;
  background: linear-gradient(0deg, rgba(56, 85, 241, 0.05) 0%, rgba(56, 85, 241, 0.05) 100%), #FFF;
  color: #3855F1;
  text-align: center;
  font-family: "Inter Tight";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  vertical-align: middle;
}
</style>
